export const METRIC_DATA_DECORATOR_ROUND = 'cw-round';
export const METRIC_DATA_DECORATOR_FANCY = 'cw-fancy';
export const METRIC_DATA_DECORATOR_DEFAULT = METRIC_DATA_DECORATOR_ROUND;
